import { callAdminApiGet } from "../../api/apiUtils";

export function getDeviceCustomerContactInformation(deviceId) {
  const url = `api/customer/getdevicecustomercontactinformation/${deviceId}`;

  return callAdminApiGet(url);
}
